import Images from 'app/assets/img';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as LogoutIcon } from 'app/assets/img/logout.svg';
import { useSelector } from 'react-redux';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import { AGENT_ROUTE } from 'app/pages/Agent/constants';
import RenderIf from 'app/components/RenderIf';
import { Permission } from 'app/hooks/usePermission';
import { BP_TYPE } from 'utils/constants';

export enum ACCOUNT_MNG_MENU {
  PURCHASE_HISTORY,
  ORDER_MANAGEMENT,
  PERSONAL_INFO,
  LOGOUT,
  CHECK_TICKET,
  BOOKING_SLOTS,
  RESERVATION_HISTORY,
  FILES_MANAGEMENT,
  AGENT_HISTORY,
  AGENT_PROFILE,
  APPROVE_ORDER,
  ACCOUNT_PAYMENT_GUIDE,
  AUTO_DEPOSIT,
  AGENT_LIST_ACCOUNT,
}

const AccountManager = (props: {
  onClickHistory?: () => void;
  onClickProfile?: () => void;
  onClickLogout?: () => void;
  menuActive?: ACCOUNT_MNG_MENU;
}) => {
  const { menuActive } = props;

  const { onLogout, onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  const renderMessCofirmLogout = (message: string) => {
    const partsOfMsg = message.split('\\n\\r');
    return partsOfMsg.map((i, index) => (
      <p
        className="mx-auto mt-px text-center text-sm font-normal leading-[18px] text-[#1c1b1f] first:mt-0"
        key={`${i}-${index}`}
      >
        {i}
      </p>
    ));
  };

  const onConfirmLogout = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2c.menu.logout'] ?? '',
      content: renderMessCofirmLogout(
        translations?.['b2c.text.logoutConfirm'] ?? '',
      ),
      buttons: [
        {
          text: translations?.['b2c.btn.cancel'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2c.txt.confirm'] ?? '',
          bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
          color: 'white',
          onClick: () => {
            onCloseDialogNoti();
            onLogout();
          },
        },
      ],
      maskClosable: false,
      icon: <LogoutIcon />,
      onCloseDialog: onCloseDialogNoti,
    });
  };

  return (
    <div className="rounded-[20px] bg-white p-6 shadow-[0px_20px_20px_0px_#0000000D]">
      <div>
        <h4 className="mb-6 text-xl font-semibold uppercase text-black">
          {translations?.['b2c.account.mng'] ?? ''}
        </h4>
      </div>
      {menuActive &&
        [
          ACCOUNT_MNG_MENU.AGENT_HISTORY,
          ACCOUNT_MNG_MENU.AGENT_PROFILE,
          ACCOUNT_MNG_MENU.AGENT_LIST_ACCOUNT,
        ].includes(menuActive) ? (
        <>
          <Link to={AGENT_ROUTE.AGENT_PROFILE}>
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_PROFILE}
            >
              <img src={Images.AgentIcon} alt="" />
              {translations?.['b2b.menu.agent-profile'] ?? ''}
            </AccountMenuItem>
          </Link>
          <Link to={AGENT_ROUTE.AGENT_LIST_ACCOUNT}>
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_LIST_ACCOUNT}
            >
              <img src={Images.UserIcon} alt="" />
              {translations?.['b2b.menu.agent-list-account'] ?? ''}
            </AccountMenuItem>
          </Link>
          {!isProxyBuyer && (
            <Link to={AGENT_ROUTE.AGENT_TRANSACTION_HISTORY}>
              <AccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.AGENT_HISTORY}
              >
                <img src={Images.HistoryIcon} alt="" />
                {translations?.['b2b.menu.agent-transaction-history'] ?? ''}
              </AccountMenuItem>
            </Link>
          )}
        </>
      ) : (
        <>
          <Link to="/account">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.PURCHASE_HISTORY}
            >
              <img src={Images.HistoryIcon} alt="" />
              {translations?.['b2c.txt.order-history'] ?? ''}
            </AccountMenuItem>
          </Link>
          <RenderIf condition={isSaleMng && !isProxyBuyer}>
            <Link to="/approve-order">
              <AccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.APPROVE_ORDER}
              >
                <img src={Images.CheckTicketIcon} alt="" />
                {translations?.['b2b.txt.approveOrder'] ?? ''}
              </AccountMenuItem>
            </Link>
          </RenderIf>
          <Link to="/order-management">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.ORDER_MANAGEMENT}
            >
              <img
                src={Images.AutoDeposit}
                alt="OrderManager"
                style={{ transform: 'translateX(-3px)', marginRight: 2 }}
              />
              {translations?.['b2b.orderManager'] ?? 'Đơn hàng Combo Holiday'}
            </AccountMenuItem>
          </Link>
          <Link to="/check-tickets">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.CHECK_TICKET}
            >
              <img src={Images.CheckTicketIcon} alt="" />
              {translations?.['b2b.txt.check-ticket'] ?? ''}
            </AccountMenuItem>
          </Link>
          {/* <Link to="/restaurant/booking-slots">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.BOOKING_SLOTS}
            >
              <img src={Images.CheckTicketIcon} alt="" />
              {translations?.['b2b.txt.bookingLookup'] ?? 'Tra cứu đặt chỗ'}
            </StyledAccountMenuItem>
          </Link> bỏ reservation version 1 */}
          <Link to="/reservation-history">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.RESERVATION_HISTORY}
            >
              <img src={Images.HistoryIcon} alt="" />
              {translations?.['b2b.restaurantHistory.menu'] ??
                'Lịch sử đặt bàn nhà hàng'}
            </AccountMenuItem>
          </Link>
          <Link to="/files-management">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.FILES_MANAGEMENT}
            >
              <img src={Images.DocumentIcon} alt="" />
              {translations?.['b2b.account.files-management'] ?? ''}
            </AccountMenuItem>
          </Link>
          <Link to="/profile">
            <AccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.PERSONAL_INFO}
            >
              <img src={Images.UserIcon} alt="" />
              {translations?.['b2c.menu.account'] ?? ''}
            </AccountMenuItem>
          </Link>
          <RenderIf
            condition={
              infoUser?.role_code === Permission.ROLE_SALE_MANAGER &&
              !isProxyBuyer &&
              !!infoUser.businessPartner?.bankInfo?.tid
            }
          >
            <Link to="/auto-deposit">
              <AccountMenuItem
                isSelected={menuActive === ACCOUNT_MNG_MENU.AUTO_DEPOSIT}
              >
                <img
                  src={Images.AutoDeposit}
                  alt="TopUpDeposit"
                  style={{ transform: 'translateX(-3px)', marginRight: 2 }}
                />
                {translations?.['b2b.autoDeposit'] ?? ''}
              </AccountMenuItem>
            </Link>
          </RenderIf>
          {/* <Link to="/payment-guide">
            <StyledAccountMenuItem
              isSelected={menuActive === ACCOUNT_MNG_MENU.ACCOUNT_PAYMENT_GUIDE}
            >
              <img src={Images.AccountPaymentGuideIcon} alt="" />
              {translations?.['b2b.txt.manualDeposit'] ?? ''}
            </StyledAccountMenuItem>
          </Link> */}
          <AccountMenuItem
            onClick={onConfirmLogout}
            isSelected={menuActive === ACCOUNT_MNG_MENU.LOGOUT}
          >
            <img src={Images.LogoutIcon} alt="" />
            {translations?.['b2c.menu.logout'] ?? ''}
          </AccountMenuItem>
        </>
      )}
    </div>
  );
};

export default AccountManager;

const AccountMenuItem = ({
  isSelected,
  children,
  onClick,
}: {
  isSelected: boolean;
  children: ReactNode;
  onClick?: () => void;
}) => (
  <div
    className={`flex w-full cursor-pointer items-center rounded-[20px] px-4 py-3 text-sm font-normal text-black [&_img]:mr-2 ${isSelected ? 'bg-[#FFEDEB80]' : 'bg-transparent'
      }`}
    onClick={onClick}
  >
    {children}
  </div>
);
